
import { mapState } from 'vuex'
import LayoutMixin from '@/mixins/layout'
import PCView from './components/-pc.vue'
import MobileVue from './mobile/-index.vue'
import SupportTop from '@/components/page/support-top.vue'
import SupportNav from '@/components/page/support-nav.vue'
import captcha from '@/utils/captcha.js'
import { isHiddenHeaderFn } from '@/utils/utils'
import { QueryTrackingClick } from '@/reporter/track'
export default {
  components: {
    SupportNav,
    SupportTop,
    PCView,
    MobileVue,
  },
  mixins: [LayoutMixin],
  beforeRouteEnter(to, from, next) {
    // 如果从结果页跳转过来
    if (from?.name?.includes('querySupport-waybill-mobile-result')) {
      next((vm) => {
        if (vm.waybillParams) {
          vm.initWaybillParams = vm.waybillParams
        }
      })
    }
    next()
  },
  data() {
    return {
      initWaybillParams: null,
      trackMap: {
        query: QueryTrackingClick,
      },
    }
  },
  head() {
    return {
      title:
        this.$t(`serviceSupport.querySupport.waybill`) +
        this.$t('navs.suffixName'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('descriptions.waybill'),
        },
      ],
    }
  },
  computed: {
    ...mapState({
      locale: (state) => state.locale,
      resizeInfo: (state) => state.resizeInfo,
      waybillParams: (state) => state.support.waybillParams,
    }),
    // 判断是否需要隐藏公共部分
    isHiddenHeader() {
      return isHiddenHeaderFn(this.$route)
    },
    // 根据 viewType 参数强制切换 PC/Mobile 视图，不传则走原有屏幕宽度逻辑
    isMobileView() {
      const viewType = this.$route?.query?.viewType || ''
      if (viewType === '0' || viewType === 0 ) return false // 强制 PC
      if (viewType === '1' || viewType === 1 ) return true  // 强制 mobile
      return this.resizeInfo?.isMobile    // 原逻辑不变
    },
  },
  created() {
    if (process.client) {
      const options = { lang: this.locale, app: this }
      if (this.$route.query.sysCode === 'ICCSP-ZALO') {
        options.scene = '3' // 小程序 顺丰-谷歌[静默]-腾讯
      }
      captcha.init(options)
      this.$TencentQRCode = captcha
      this.getTimeZone() // 获取默认时区
    }
  },
  methods: {
    async getTimeZone() {
      try {
        const res = await this.$API.support.getTimeZoneApi()
        this.$store.commit('support/SET_INIT_TIME_ZONE', res)
      } catch (error) {
        console.error('Get timezone failed:', error)
      }
    },
    trackFn(type, properties) {
      if (this.trackMap[type]) {
        this.trackMap[type](properties)
      }
    },
    track(type) {
      this.trackFn(type)
    },
  },
}
